import { NivalizTransactionVolumeLineChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast30DaysNivalizTransactionVolumeLineChart } from './use-last-30-days-nivaliz-transaction-volume-line-chart';

export interface Last30DaysNivalizTransactionVolumeLineChartProps {
    accountId: string;
    navigateUrl?: string;
}

export const Last30DaysNivalizTransactionVolumeLineChart = (props: Last30DaysNivalizTransactionVolumeLineChartProps) => {
    const { data, isLoading, subtitle, navigateUrl } = useLast30DaysNivalizTransactionVolumeLineChart(props);

    return (
        <StatisticsCard
            chartKey={NivalizTransactionVolumeLineChart.definition.key}
            navigateUrl={navigateUrl}
            title={
                <FormattedMessage
                    id='platform.statistics.nivaliz.last-30-days-nivaliz-transaction-volume-line-chart.title'
                    description='Title of the Nivaliz dashboard chart showing completed transaction volume over the last 30 days'
                    defaultMessage='Completed transaction volume'
                />
            }
            subtitle={subtitle}
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <NivalizTransactionVolumeLineChart
                        data={data}
                        minHeight={80}
                        showLabels='minimal'
                        tooltipShared
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
